<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'drugId'
        label= '药品id'>
      </el-table-column>
      <el-table-column
        prop= 'drugName'
        label= '药品名称'>
      </el-table-column>
      <el-table-column
        prop= 'biotaGrowthStageDiseaseInsectPestId'
        label= '生长阶段id'>
      </el-table-column>
      <el-table-column
        prop= 'diseaseInsectPestId'
        label= '病虫害id'>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '使用说明'>
      </el-table-column>
      <el-table-column
        prop= 'type'
        label= '用药类型'>
      </el-table-column>
      <el-table-column
        prop= 'attenuationValue'
        label= '稀释倍液'>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '100'>
        <template slot-scope='scope'>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="药品id" :label-width="formLabelWidth" prop="drugId">
          <el-input type="number" v-model.number="form.drugId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="药品名称" :label-width="formLabelWidth" prop="drugName">
          <el-input v-model="form.drugName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="生长阶段id" :label-width="formLabelWidth" prop="biotaGrowthStageDiseaseInsectPestId">
          <el-input type="number" v-model.number="form.biotaGrowthStageDiseaseInsectPestId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="病虫害id" :label-width="formLabelWidth" prop="diseaseInsectPestId">
          <el-input type="number" v-model.number="form.diseaseInsectPestId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="使用说明" :label-width="formLabelWidth" prop="descr">
          <el-input v-model="form.descr" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="用药类型" :label-width="formLabelWidth" prop="type">
          <el-input type="number" v-model.number="form.type" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="稀释倍液" :label-width="formLabelWidth" prop="attenuationValue">
          <el-input type="number" v-model.number="form.attenuationValue" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  data () {
    return {
      
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        drugId: null,
        drugName: null,
        biotaGrowthStageDiseaseInsectPestId: null,
        diseaseInsectPestId: null,
        descr: null,
        type: null,
        attenuationValue: null
      },
      rules: {
        drugId: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}],
        biotaGrowthStageDiseaseInsectPestId: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}],
        diseaseInsectPestId: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}],
        type: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}],
        attenuationValue: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}]
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0
    }
  },
  created () {
    
    this.query()
  },
  methods: {
    del (row) {
      let that = this
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/diseaseInsectPestDrug/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/diseaseInsectPestDrug/listPage?current=${that.current}&pageSize=${that.pageSize}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },
    digAdd () {
      this.form = {}
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          let url = '/diseaseInsectPestDrug/add'
          if (that.form.id) {
            url = '/diseaseInsectPestDrug/edit'
          }
          requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/diseaseInsectPestDrug/Index.vue